import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GbpublikationService, PublikationSearchRequestMeta } from '../../../core/gb-api';
import { submit } from './publikation.function';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { GbAmtComponent } from '../../../shared/widgets/gb-amt/gb-amt.component';
import { TimepointService } from '../../../core/services/timepoint.service';
import { GbAmtSearchMode } from '../../../shared/widgets/gb-amt/gbAmtSearchMode';
import { GbGemeindeSearchMode } from '../../../shared/widgets/gb-gemeinde/gbGemeindeSearchMode';
import { SecurityData } from '../../../security/security-data';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { AbstractSearchComponent } from '../../../shared/components/abstract-component/abstract-search.component';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { MetaDirective } from '../../../shared/directives/meta.directive';
import { CapFormRowDirective } from '../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../shared/directives/meta-validator.directive';
import { DatepickerComponent } from '../../../shared/datepicker/datepicker.component';
import { GrundstueckNummerComponent } from '../../../shared/widgets/grundstueck-nummer/grundstueck-nummer.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-publikation-suche',
  templateUrl: './publikation-suche.component.html',
  styleUrls: ['./publikation-suche.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    FormsModule,
    MetaDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    GbAmtComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    DatepickerComponent,
    GrundstueckNummerComponent,
    TranslatePipe
  ]
})
export class PublikationSucheComponent extends AbstractSearchComponent implements OnInit, OnDestroy {
  @ViewChild('form', { static: false })
  form: NgForm;

  @ViewChild(GbAmtComponent, { static: false })
  private gbAmt: GbAmtComponent;

  publikation: PublikationSearchRequestMeta;

  gbAmtSearchMode = GbAmtSearchMode.PUBLIKATIONS_REGISTER_SEARCH;
  gbGemeindeSearchMode = GbGemeindeSearchMode.PUBLIKATIONS_REGISTER_SEARCH;

  constructor(
    private publikationService: GbpublikationService,
    stateService: SearchStateService,
    private route: ActivatedRoute,
    private router: Router,
    private timepointService: TimepointService,
    private securityData: SecurityData
  ) {
    super(stateService);
    keysToTranslate<string>([
      'publikationAmtHeading',
      'publikationAmtHeading',
      'publikationDateHeading',
      'EigentümerBisher',
      'EigentümerNeu',
      'MitSonderrechten',
      'MitGebäuden',
      'DatumEingabe',
      'Bemerkung',
      'publikation.suche',
      'publikation.SucheTitel',
      'publikation.search.breadcrumb'
    ]);
  }

  ngOnInit() {
    this.addSub(
      this.publikationService.searchPublikationTemplate().subscribe({
        next: (result) => {
          this.publikation = this.copyLastRequest(result);
        },
        error: (error) => {
          if (error.status === 403) {
            this.securityData.actionUrl = this.router.url;
            this.router.navigate(['/security/forbidden']);
          }
        }
      })
    );
  }

  emptyGbAmtSearch() {
    this.gbAmt.onClear();
    this.publikation.grundbuchamtId = undefined;
  }

  onSubmit(): void {
    this.stateService.lastRequest = this.publikation;
    this.timepointService.resetTimepoint();
    submit(this.form, this.publikation, this.router, this.route);
  }

  onReset(): void {
    this.form.reset();
    this.addSub(
      this.publikationService.searchPublikationTemplate().subscribe((template) => {
        this.publikation = template;
        this.gbAmt.focus();
      })
    );
  }
}
